$giper_baza_unit_sand_dump $giper_baza_vary_edit
	land $giper_baza_land
	sand $giper_baza_unit_sand
